__turbopack_context__.v({
  "backButton": "ScreenSwitcher-module__D50MeG__backButton",
  "buttonContainer": "ScreenSwitcher-module__D50MeG__buttonContainer",
  "description": "ScreenSwitcher-module__D50MeG__description",
  "footer": "ScreenSwitcher-module__D50MeG__footer",
  "formContainer": "ScreenSwitcher-module__D50MeG__formContainer",
  "renderStart": "ScreenSwitcher-module__D50MeG__renderStart",
  "resendButton": "ScreenSwitcher-module__D50MeG__resendButton",
});
